export default {
  /***
   * Função para criar ou atualizar um cookie.
   * @param {String} name Nome do cookie.
   * @param {mixed} content Conteúdo do cookie.
   * @param {String|Number} expiration Tempo de expiração do cookie em minutos.
   * @param {String} domain Dominio do cookie. Note: The domain must match the domain of the JavaScript origin. Setting cookies to foreign domains will be silently ignored.
   */
  createCookie(name, content, expiration = null, sameSite = 'Lax', secure = false, domain = '') {
    let cookie = `${name}=${content}; path=/; SameSite=${sameSite};`;

    if (domain) cookie += ` domain=${domain};`;

    if (secure) cookie += ' Secure;';

    if (expiration) {
      var date = new Date();
      date.setTime(date.getTime() + Number(expiration) * 60 * 1000);
      cookie += ` expires=${date.toGMTString()};`;
    }

    document.cookie = cookie;
  },

  getCookie(name) {
    var cookie = ('; ' + document.cookie).split(`; ${name}=`).pop().split(';').shift();
    return cookie.length ? cookie : null;
  }
};
